import { render, staticRenderFns } from "./project_statistics_results.vue?vue&type=template&id=27b39aad&"
import script from "./project_statistics_results.vue?vue&type=script&lang=js&"
export * from "./project_statistics_results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports